import { ManifestRegistry, CollectionRegistry, PreviewRegistry } from './sdk/registries';
import { adaptLegacyTemplate } from './legacyAdapter';
import { harvardClassic } from './harvardClassic';
import { modernATSPro } from './modernATSPro';
import { faangEngineering } from './faangEngineering';
import { startupEngineer } from './startupEngineer';
import { executiveSoftwareEngineer } from './executiveSoftwareEngineer';
import { campusPlacement } from './campusPlacement';
import { internshipResume } from './internshipResume';
import { freshGraduate } from './freshGraduate';
import { mbaConsulting } from './mbaConsulting';
import { financeProfessional } from './financeProfessional';
import { productManager } from './productManager';
import { marketingSpecialist } from './marketingSpecialist';
import { uiUxDesigner } from './uiUxDesigner';
import { creativePortfolio } from './creativePortfolio';
import { mediaContentCreator } from './mediaContentCreator';
import { salesExecutive } from './salesExecutive';
import { hrProfessional } from './hrProfessional';
import { operationsManager } from './operationsManager';
import { researchCV } from './researchCV';
import { academicCV } from './academicCV';
import { governmentResume } from './governmentResume';
import { cleanMinimalATS } from './cleanMinimalATS';
import { twoColumnATS } from './twoColumnATS';

// Premium Collections
import { stanford_ats } from './premium/stanford_ats';
import { modern_blue } from './premium/modern_blue';
import { creative_studio } from './premium/creative_studio';
import { executive_black } from './premium/executive_black';
import { startup_neon } from './premium/startup_neon';
import { university_campus } from './premium/university_campus';
import { github_developer } from './premium/github_developer';
import { terminal_hacker } from './premium/terminal_hacker';
import { faang_engineering } from './premium/faang_engineering';
import { mckinsey_consulting } from './premium/mckinsey_consulting';

export const templates = {
  // Legacy / Gallery ID mappings
  'harvard-classic': harvardClassic,
  'modern-ats-pro': modernATSPro,
  'faang-engineering': faang_engineering, // Now premium FAANG Engineer
  'executive-professional': executiveSoftwareEngineer,
  'campus-placement': campusPlacement,
  'internship-hunter': internshipResume,
  'fresher-plus': freshGraduate,
  'finance-pro': financeProfessional,
  'product-consulting': mckinsey_consulting, // Now premium McKinsey Consultant
  'creative-professional': creativePortfolio,
  'clean-minimal-ats': cleanMinimalATS,
  'two-column-ats': twoColumnATS,

  // Direct V2 ID mappings
  'executive-software-engineer': executiveSoftwareEngineer,
  'internship-resume': internshipResume,
  'fresh-graduate': freshGraduate,
  'finance-professional': financeProfessional,
  'product-manager': productManager,
  'creative-portfolio': creativePortfolio,
  'startup-engineer': startupEngineer,
  'ui-ux-designer': uiUxDesigner,
  'media-content-creator': mediaContentCreator,
  'sales-executive': salesExecutive,
  'hr-professional': hrProfessional,
  'operations-manager': operationsManager,
  'mba-consulting': mbaConsulting,
  'marketing-specialist': marketingSpecialist,
  'research-cv': researchCV,
  'academic-cv': academicCV,
  'government-resume': governmentResume,

  // Premium Marketplace Collections
  'stanford-ats': stanford_ats,
  'modern-blue': modern_blue,
  'creative-studio': creative_studio,
  'executive-black': executive_black,
  'startup-neon': startup_neon,
  'university-campus': university_campus,
  'github-developer': github_developer,
  'terminal-hacker': terminal_hacker,
};

// Register standard Collections
const COLLECTIONS = [
  { id: 'ats_professional', name: 'ATS Collection', icon: '📄', order: 1, color: '#059669', description: 'Guaranteed to pass any ATS scanner' },
  { id: 'modern_professional', name: 'Modern Collection', icon: '✨', order: 2, color: '#2563EB', description: 'Clean layouts with subtle colors' },
  { id: 'creative', name: 'Creative Collection', icon: '🎨', order: 3, color: '#DB2777', description: 'Visual and design-centric layouts' },
  { id: 'executive', name: 'Executive Collection', icon: '👔', order: 4, color: '#D4AF37', description: 'Premium luxury look for leadership' },
  { id: 'startup', name: 'Startup Collection', icon: '🚀', order: 5, color: '#A855F7', description: 'Modern neon-accented tech themes' },
  { id: 'student', name: 'Student Collection', icon: '🎓', order: 6, color: '#0EA5E9', description: 'Education and fresher-first designs' },
  { id: 'developer', name: 'Developer Collection', icon: '💻', order: 7, color: '#24292E', description: 'GitHub stats, monospace, and SDE layouts' }
];

COLLECTIONS.forEach(col => CollectionRegistry.register(col));

// Populate registries with all templates
Object.keys(templates).forEach(key => {
  const legacyTmpl = templates[key];
  if (legacyTmpl) {
    const adapted = adaptLegacyTemplate(legacyTmpl);
    ManifestRegistry.register(adapted);
    PreviewRegistry.register(key, legacyTmpl.assets || {});
  }
});

export function getTemplate(templateId) {
  const template = templates[templateId];
  if (!template) {
    throw new Error(`TemplateNotFound: Template "${templateId}" is not registered in the frontend registry.`);
  }
  return template;
}

